// extracted by mini-css-extract-plugin
export var highlightFade = "_2o-4";
export var highlighted = "_2o-3";
export var table = "_2o-1";
export var tableContainer = "_2o-0";
export var totalsRow = "_2o-2";